import { BORROWER_NAME_MIN_LENGTH } from 'utils/constants';
import { LoanInformationVariables } from 'enums/LoanInformationVariables';

import { BorrowerInformationLabel } from './borrowerInformation.enums';

export const validateLatinLetters = (value: string, fieldName: string) => {
  const regex = /^[a-zA-Z]+$/;

  if (!regex.test(value)) {
    return `${fieldName} can only contain Latin letters`;
  }
};

export const validateFirstName = (value: string, fieldName: string) => {
  if (value.trim().length < BORROWER_NAME_MIN_LENGTH) {
    return `${fieldName} cannot be less than 2 characters`;
  }

  return validateLatinLetters(value, fieldName);
};

export const validateLastName = (value: string, fieldName: string) => {
  if (value.trim().length < BORROWER_NAME_MIN_LENGTH) {
    return `${fieldName} cannot be less than 2 characters`;
  }

  // allow "a-z", "'", "-" and space
  const regex = /^[a-zA-Z\s'-]+$/;

  if (!regex.test(value)) {
    return `${LoanInformationVariables.LastName} can only contain Latin letters, apostrophes and hyphens`;
  }
};

export const validateCityField = (value: string, fieldName: string) => {
  // allow "a-z", space
  const regex = /^[a-zA-Z\s]+$/;

  if (!regex.test(value)) {
    return `${fieldName} can only contain Latin letters`;
  }
};

export const removeIncorrectSymbols = (value: string) => {
  return value
    .replace(/[^a-zA-Z0-9]/g, ' ')
    .replace(/\s+/g, ' ')
    .trimStart();
};

export const getAddressCaptionMessage = (label: BorrowerInformationLabel) => {
  return `${label} can only contain letters and numbers. Commas and other special characters are not allowed`;
};
